import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import podetailImage from "../../assests/images/Po details.png";
import EditIcon from "@mui/icons-material/Edit";
import Drawer from "@mui/material/Drawer";
import SupportChat from "../support/chat";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import _ from "lodash";
import { getSecPermission, isEmptyDash, returnValidVal, totalInr, strToDate,trimString, returnRateVal, toFixedNum } from "../../constant";
import Tooltip from '@mui/material/Tooltip';
import { lrServices } from "../../services/lrServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import PackageDocuments from "../projectManagerScreens/packageDocuments";
import TrackOrder from "../common/trackOrder";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import P2PDownload from "../common/p2pDownload";
import { commonServices } from "../../services/commonServices";

const initialColumns = [
  { id: "poNumber", label: "PO No.", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "productNumber", label: "Product ID", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "productName", label: "Product Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "hsnSacCode", label: "HSN Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "quantity", label: "Open Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "lrQuantity", label: "LR Quantitiy", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "totalValue", label: "Total Value", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "RATE" },
];
// const style1 = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
// };

const permissionInit = {
  create: false,
  read: false,
  update: false,
  delete: false,
};

function DeatilLr() {
  const qcListing = {
    currentPage: 1,
    totalPages: 20,
  }
  const [inputPage, setInputPage] = useState(qcListing?.currentPage || 1);

  const { id } = useParams();
  let navigate = useNavigate();

  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [filterFormData, setFilterFormData] = useState("");
  const [columns, setColumns] = useState(initialColumns);
  const [trackOrderData, setTrackOrderData] = useState("");
  const [isMediaListModalOpen, setIsMediaListModalOpen] = useState(false);
  const [uploadFilesObj, setUploadFilesObj] = useState({});
  const [selectedPOArr, setSelectedPOArr] = useState([id]);

  const [secLRPermission, setSecLRPermission] = useState({
    "LR_LISTING": permissionInit,
    "LR_DETAIL": permissionInit,
    "CREATE_LR": permissionInit,
    "TRACK_ORDER_LR": permissionInit,
    "EDIT_LR": permissionInit,
    "DOWNLOAD_LR": permissionInit,
  });

  const [lrDetails, setLRDetails] = React.useState({ "Route_Details": [], "Transporter_Details": [], "Documents": [] });
  const [productsListing, setProductsListing] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    products: [],
  });

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    getFieldConfig("P2P", "LR");
    let secLRPermissionInit = _.cloneDeep(secLRPermission);
    let obj = {};
    for (let key in secLRPermissionInit) {
      obj[key] = getSecPermission(key);
    }
    setSecLRPermission(obj);

    // if (UserObj?.role.name == "VENDOR") {
    //   getVendorDetails();
    // }
  }, []);

  const handleCloseAlert = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  // const getVendorDetails = (url) => {
  //   setIsLoading(true);
  //   vendorServices
  //     .getVendorDetails()
  //     .then(function (response) { 
  //       if (response?.data?.success == true) {
  //         setVendorDetails(response?.data?.data);
  //       }
  //     })
  //     .catch(function (error) { 
  //       setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
  //     })
  //     .finally((param) => {
  //       setIsLoading(false);
  //     });
  // };

  const getFieldConfig = (moduleName, page) => {
    setIsLoading(true);
    let qParam = `?moduleName=${moduleName}&page=${page}`;
    let promise = commonServices.getFieldConfig(qParam);
    promise.then((res) => {
      if (res.data.success === true) {
        // setLRDetails(res.data?.data);        
        getDetails(id, res.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const getDetails = (param, fieldData) => {
    setIsLoading(true);
    let url = `/${param}`;
    let promise = lrServices.getLRListing(url);
    promise.then((res) => {
      if (res.data.success === true) {
        let obj = {...res.data?.data};
        for (let i = 0; i < fieldData?.sections.length; i++) {
          if (fieldData?.sections[i]?.title == "Transporter_Details") {
            for (let j = 0; j < fieldData?.sections[i]?.fields.length; j++) {
              fieldData.sections[i].fields[j].value = getFieldValue(res.data?.data, fieldData?.sections[i]?.fields[j]);              
            }
            obj["Transporter_Details"] =  fieldData.sections[i].fields;
          }
          
          if (fieldData?.sections[i]?.title == "Route_Details") {
            for (let j = 0; j < fieldData?.sections[i]?.fields.length; j++) {
              fieldData.sections[i].fields[j].value = getFieldValue(res.data?.data, fieldData?.sections[i]?.fields[j]);              
            }
            obj["Route_Details"] =  fieldData.sections[i].fields;
          }
          
          if (fieldData?.sections[i]?.title == "Documents") {
            for (let j = 0; j < fieldData?.sections[i]?.fields.length; j++) {
              fieldData.sections[i].fields[j].value = getDocumentValue(res.data?.data, fieldData?.sections[i]?.fields[j]);              
            }
            obj["Documents"] =  fieldData.sections[i].fields;
          }
        }
        // console.log(obj);        
        setLRDetails(obj);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }
  
  const getFieldValue = (resData, fieldData) => {
    let val = "";
      if (fieldData?.static == true) {
        if (fieldData.type == "String" || fieldData.type == "Dropdown" || fieldData.type == "Number") {
          val = returnValidVal(resData[fieldData?.uniqueName], "");                
        }
        if (fieldData.type == "Date") {
          val = returnValidVal(strToDate(resData[fieldData?.uniqueName], ""));                
        }
        if (fieldData.type == "File") {
          val = getFileValue(resData[fieldData?.uniqueName]);                
        }
      }
      else {
        if (fieldData.type == "String" || fieldData.type == "Dropdown" || fieldData.type == "Number") {
          val = returnValidVal(resData["additionalFields"][fieldData?.uniqueName], "");                
        }
        if (fieldData.type == "Date") {
          val = returnValidVal(strToDate(resData["additionalFields"][fieldData?.uniqueName], ""));                
        }
        if (fieldData.type == "File") {
          val = getFileValue(resData["additionalFields"][fieldData?.uniqueName]);                
        }
      }
      return val;
  }
  
  const getDocumentValue = (resData, fieldData) => {
    let val = "";
      if (fieldData?.static == true) {
        if (fieldData.type == "File") {
          val = resData["documents"]?.filter((ele, i) => ele?.uniqueName == fieldData?.uniqueName)[0];                
        }
      }
      else {
        if (fieldData.type == "File") {
          val = resData["documents"]?.filter((ele, i) => ele?.uniqueName == fieldData?.uniqueName)[0];                    
        }
      }
      return val;
  }

  const getFileValue = (data) => {
    console.log(data); 
    return ""   
  }

  const getDropdownOption = (data) => {

  }

  useEffect(() => {
    getProductsListing(requestPayload, filterText, filterFormData);
  }, [requestPayload]);

  const getProductsListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }

    let promise = lrServices.getLRProductList(id, param);
    promise.then((res) => {
      if (res.data.success === true) {
        setProductsListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };


  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= productsListing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(productsListing?.currentPage);
      }
    }
  };
  // const userRole = UserObj ? UserObj?.role?.name : "";
  // const [opendocumentattchementmodal, setOpenDocumentAttchementModal] = useState(false);

  const onSortChange = (index, sortBy, sortOrder) => {
    // let newSortLael = (sortOrder == "asc") ? "desc" : "asc";

    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };
  const onFilterSubmit = () => {
    getProductsListing(requestPayload, filterText);
  };

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);

    }, 800),
    []
  );

  const onEditClick = () => {
    navigate(`/admin/vendor-LR-Creation?lrId=${id}`);
  }

  const handleClick = (document, index) => {
    setUploadFilesObj(document);
    setIsMediaListModalOpen(true);
  }

  const closeMediaListModal = () => {
    setUploadFilesObj({});
    setIsMediaListModalOpen(false);
  };

  const dummyFunCall = () => {

  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };
  const [state, dispatch] = React.useReducer(reducer, { open: false });

  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };
  const DrawerList = (
    <TrackOrder steps={trackOrderData} close={() => toggleDrawer(false)()} refresh={() => handleTrackOrder()} />
  );

  const [selectedLRId, setSelectedLRId] = useState('');

  const onLRCheckChange = (isChecked, row) => {
    if (isChecked) {
      setSelectedLRId(row.purchaseOrderId);
    } else {
      setSelectedLRId('');
    }
  };

  const handleTrackOrder = () => {
    if (selectedLRId.length < 1) {
      setAlertComponent({ open: true, type: "error", message: `Please select atleast one PO. ` });
      return;
    }
    setIsLoading(true);
    purchaseOrderServices.getPOTrackOrder(selectedLRId)
      .then(response => {
        if (response?.data?.success == true) {
          toggleDrawer(true)();
          setTrackOrderData(response?.data?.data);
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}. ` });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse ms-auto">
            <div className="search_main">
              <h5>LR Detail</h5>
            </div>

            <div className="vendor_listing_lr_block_body" style={{alignItems: "center"}}>
              {/* <button className="create_btn_lr_creations">
                Create Gate Entry
              </button> */}
              {(secLRPermission?.EDIT_LR?.read == true) && <button
                onClick={onEditClick}
                className="gate_btn_lr_creations"
              >
                <EditIcon />
                Edit LR
              </button>}
              
              {(secLRPermission?.DOWNLOAD_LR?.read == true) && <P2PDownload
                  url={`/v1/common/lorry-receipts/download`}
                  selectedArr={selectedPOArr}
                  selectedPOJsonArr={[lrDetails]}
                  filterFormData={{lrNumber: lrDetails?.lrNumber}}
                  filterText={filterText}
                  type="LR"
                />}
              <div className="track_order_react_row">

                <button
                  onClick={handleTrackOrder}
                  class="vendor_btn vendor_maine_contents"
                >
                  Track Order
                </button>

                <Drawer
                  anchor="right"
                  open={state.open}
                  onClose={toggleDrawer(false)}
                  style={{ zIndex: 99999 }}
                >
                  {DrawerList}
                </Drawer>
              </div>
              <Link to="/admin/vendor-Listing-Lr" style={{ textDecoration: "none" }}>
              
              <button className="btn btn-danger">Back</button>
              </Link>  
              {/* <button className="btn btn-danger">Cancel</button> */}
            </div>
          </div>
          <div className="lets_head_purchase_number_buyer_react_blocklist">
            <div className="main_row_detail_lr_react_1">
              <div className="lets_react_order_listing_level_buyer">
                <div className="content_react_level_details">
                  <img src={podetailImage} alt="" />
                  <p className="lets_block_react_details_purchase">
                    LR Number : {lrDetails?.lrNumber}
                  </p>
                </div>
                <div className="lets_pending_react_body">
                  Order Date :
                  <span className="date_solutions"> {strToDate(lrDetails?.createdAt)} </span>
                  <div className="solution_asen_statsu_pending">
                    Status :<p className="date_solutions_status">{lrDetails?.status}</p>
                  </div>
                </div>
              </div>
              <div className="lets_table_buyername_react_suntech_2">
  <style>
    {`
      tbody tr:nth-child(even) { 
        background-color: transparent !important; 
      }
    `}
  </style>
  <table>
    <tbody className="tbody_suntech">
      {lrDetails?.Transporter_Details?.map((ele, i) => (
        (ele?.type === "String" || ele?.type === "Number" || ele?.type === "Dropdown" || ele?.type === "Date") && (
          <tr key={`transporter_${i}`}>
            <td className="name_asn_details_suntech_react_id">{ele?.name}</td>
            <td>:</td>
            {(ele?.uniqueName === "totalInvoiceAmount" || ele?.uniqueName === "freightCharges" ) ? <td>
              {/* <Tooltip title={ele?.value}> {trimString(ele?.value, 20)}</Tooltip> */}
              {returnRateVal(ele?.value)}
            </td> 
            : (ele?.type === "Number") ? <td>
              <Tooltip title={ele?.value}> {toFixedNum(ele?.value, 2)}</Tooltip>
            </td> 
            : <td>
              <Tooltip title={ele?.value}> {trimString(ele?.value, 20)}</Tooltip>
            </td>}
          </tr>
        )
      ))}
    </tbody>
  </table>

  <table>
    <tbody>
      {lrDetails?.Route_Details?.map((ele, i) => (
        (ele?.type === "String" || ele?.type === "Number" || ele?.type === "Dropdown" || ele?.type === "Date") && (
          <tr key={`route_${i}`}>
            <td className="name_asn_details_suntech_react_id">
            <Tooltip title={ele?.name}> {trimString(ele?.name, 20)}</Tooltip>
            </td>
            <td>:</td>
            { (ele?.type === "Number") ? <td>
              <Tooltip title={ele?.value}> {toFixedNum(ele?.value, 2)}</Tooltip>
            </td> 
            : <td>
              <Tooltip title={ele?.value}> {trimString(ele?.value, 20)}</Tooltip>
            </td>}
            
          </tr>
        )
      ))}
    </tbody>
  </table>
  <table>
    <tbody>
      {lrDetails?.Documents?.map((row, rowIndex) => (
        <tr key={`document_${row?._id}`}>
          <td className="name_asn_details_suntech_react_id">{row?.name}</td>
          <td>:</td>
          <td>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => handleClick(row?.value, rowIndex)}
            >
              View
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
            </div>
          </div>
          <div className="search_filter_outers_react ms-auto">
            <div className="search_main">
              <div id="custom-search-input">
                <div className="input-group col-md-12">
                  <input
                    type="text"
                    className="form-control input-lg"
                    placeholder="Search here"
                    fdprocessedid="8achb"

                    onChange={onFilterTextChange}
                    value={filterText}
                    onKeyPress={onKeyPressHandler}
                  />
                  <span className="input-group-btn">
                    <button
                      className="btn btn-info btn-lg"
                      type="button"
                      fdprocessedid="trsp06"
                    >
                      <span className="glyphicon glyphicon-search">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-search"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                        </svg>
                      </span>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="listing_main listing_main_dragdropcontext_body" style={{ overflowX: "scroll", marginTop: "-20px" }}>
          <table className="">
          <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                <tr>
                  <th className="vendor_tabels">
                    {/* <input type="checkbox" /> */}
                  </th>
                  {columns.map((column, index) => (<>
                    <th className="vendor_tabels ">
                      <div className="PoDetailTableHeading">
                        <div className="d-flex">
                          <p>{column?.label}</p>
                          {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                            {(column.sortLabel != "asc") && <img src={topArrow} />}
                            {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                            {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                            {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                          </span>}
                        </div>
                      </div>
                    </th>
                  </>))}
                </tr>
              </thead>
              <tbody style={{ overflowY: "scroll", width: "200px" }}>
                {productsListing?.products.length < 1 && <>
                  <tr>
                    <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                  </tr>
                </>}
                {productsListing?.products?.map((row, rowIndex) => (
                  <tr key={rowIndex} className="maine_tr_vendor">
                    <td>
                      <input type="checkbox" checked={selectedLRId === row.purchaseOrderId} onChange={(e) => onLRCheckChange(e.target.checked, row, rowIndex)} />
                    </td>
                    {columns.map((column, index) => (<>
                      {(column.id == "poNumber") ? (<td className="block_solar">
                        <p className="list-details-para" >
                          {row[column.id]}
                        </p>
                      </td>) : (column.id == "totalValue") ? (<td>
                        <p  >
                          {returnRateVal(row[column?.id])}
                          {/* ₹{totalInr(isEmptyDash(row[column.id]) ? "0.00" : row[column.id])} */}
                        </p>
                      </td>) :
                        <td key={index} >
                           <Tooltip title={row[column.id] || "N/A"}>
                              {trimString(row[column.id], 20 || "N/A")}
                              </Tooltip>
                        </td>
                      }
                    </>
                    ))}

                  </tr>
                ))}

              </tbody>
            </table>
          </div>
          <div className="lets_pagination_package_listing_react">
            <div className="pagination_select_react_packagelr_detail">
              <select
                className="form-select packagelrlisting from-hs"
                onChange={onPageSizeChange}
                value={requestPayload?.pageSize}
              >
                <option selected="1">10</option>
                <option value="2">15</option>
                <option value="3">20</option>
                <option value="4">25</option>
                <option value="5">50</option>
              </select>
              <span className="react_text_showing">
                {` Showing rows ${Number(productsListing?.pageSize) * Number(productsListing?.currentPage - 1) + 1} to ${Number(productsListing?.pageSize) * Number(productsListing?.currentPage - 1) + Number(productsListing?.products?.length)} of ${productsListing?.totalItems}`}
              </span>
            </div>
            <Stack spacing={2}>
              <Pagination
                count={productsListing?.totalPages}
                page={productsListing?.currentPage}
                onChange={(event, page) => {
                  setInputPage(page);
                  onPaginationChange(event, page);
                }}
                renderItem={(item) => {
                  if (item.page === productsListing?.currentPage) {
                    return (
                      <input
                        className="form-control form-hasw"
                        type="text"
                        value={inputPage}
                        onChange={handleInputChange}
                        onKeyDown={handleInputSubmit}
                        style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                      />
                    );
                  }
                  return (
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  );
                }}
              // count={5}
              // renderItem={(item) => (
              //   <PaginationItem
              //     className="pagination_react_listings"
              //     slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
              //     {...item}
              //   />
              // )}
              />
            </Stack>
          </div>
          {/* Documment Attchement */}
          {/* <Modal
                  open={opendocumentattchementmodal}
                  onClose={() => setOpenDocumentAttchementModal(false)}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style1} className="modal_react_controlpanel_employees">
                    <div className="modal-header">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">Document Attached</h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        fdprocessedid="kum8iho"
                        onClick={() => setOpenDocumentAttchementModal(false)}
                      ></button>
                    </div>
                    <div class="modal-bodys">
                    <table>
                      
                        <tr>
                            <td className="name_asn_details_suntech_react_ids">
                              LR
                            </td>
                              <td>:</td>
                            <td>
                              <div className="vendor_maine_content">
                            <PictureAsPdfIcon className="icon_close_control"/>LR</div></td>
                            <td><RemoveRedEyeIcon className="icon_close_control_eye"/></td>
                        </tr>
                        
                      <tr>
                      <td className="name_asn_details_suntech_react_ids">
                      E-WAY Bill
                          </td>
                          <td>:</td>
                        <td>
                          <div className="vendor_maine_content">
                        <PictureAsPdfIcon className="icon_close_control"/>E-WAY Bill</div></td>
                        <td><RemoveRedEyeIcon className="icon_close_control_eye"/></td>
                      </tr>
                      <tr>
                      <td className="name_asn_details_suntech_react_ids">
                      Packing List
                          </td>
                          <td>:</td>
                        <td>
                          <div className="vendor_maine_content">
                        <PictureAsPdfIcon className="icon_close_control"/>Packing List</div></td>
                        <td><RemoveRedEyeIcon className="icon_close_control_eye"/></td>
                      </tr>
                      <tr>
                      <td className="name_asn_details_suntech_react_ids">
                        Others
                          </td>
                          <td>:</td>
                        <td>
                          <div className="vendor_maine_content">
                        <PictureAsPdfIcon className="icon_close_control"/>Others</div></td>
                        <td><RemoveRedEyeIcon className="icon_close_control_eye"/></td>
                      </tr> 

                    </table>
                    <div className="danger_byns_btns">
                    <button onClick={() => setOpenDocumentAttchementModal(false)} type="button" class="btn btn-danger">Close</button>
                    </div>
                    </div>
                  </Box>
                </Modal> */}
          {/* Documment Attchement */}
        </div>
        <SupportChat
          vendorDetails={{ vendor: { _id: lrDetails?.vendorId } }}
          isP2P={true}
          P2PData={{
            isActive: true,
            vendorName: lrDetails?.vendorName,
            refType: "LR",
            referenceId: lrDetails?._id,
          }}
        />

      </div>
      <PackageDocuments
        isMediaListModalOpen={isMediaListModalOpen}
        closeMediaListModal={closeMediaListModal}
        uploadObj={uploadFilesObj}
        onUploadMedia={dummyFunCall}
        deleteFile={dummyFunCall}
        isSubmitCondition={false}
        multiupload={false}
        userDeletefile={false}
      />

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleCloseAlert}
      />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default DeatilLr;
